module.exports = __webpack_public_path__ + "image-7a4b17905bfb.png";